import(/* webpackMode: "eager" */ "/app/hub/src/app/search/[accountId]/entry/[entryId]/error.tsx");
